import * as THREE from 'three'
import { ProtoBase, easeInOutCubic } from '../ProtoBase'

/** ② スケール反転 — 手のひらの盆栽列島が、一気に実寸大へ広がる */
export class Proto2 extends ProtoBase {
  readonly title = '2. スケール反転'
  readonly desc = '目の前の盆栽サイズの日本 →「広げるぞ」で一気に実寸大の上空へ'

  private camFrom = new THREE.Vector3(0, 26, 66)
  private camTo = new THREE.Vector3(0, 120, 140)
  private tgtFrom = new THREE.Vector3(0, 22, 46)
  private tgtTo = new THREE.Vector3(0, 0, -5)

  protected start(): void {
    this.ctx.setWorld('map')
    this.ctx.controls.enabled = false
    this.applyMini()
    this.ctx.setCaption('「これが、わしの歩いた国じゃ」')
  }

  private applyMini(): void {
    const root = this.ctx.terrain.root
    root.scale.setScalar(0.05)
    root.position.set(0, 22, 46)
    this.ctx.markers.root.scale.setScalar(0.05)
    this.ctx.markers.root.position.set(0, 22, 46)
    this.ctx.markers.setLabelsVisible(false)
    this.ctx.view.setPose(this.camFrom, this.tgtFrom)
  }

  update(dt: number): void {
    this.elapsed += dt
    const t = this.elapsed % 16 // 16秒ループ

    if (t < 3.2) {
      // 盆栽フェーズ: ゆっくり回す
      const root = this.ctx.terrain.root
      root.rotation.y = Math.sin(t * 0.4) * 0.15
      this.ctx.markers.root.rotation.y = root.rotation.y
      if (t < 0.1) this.applyMini()
    } else if (t < 8.2) {
      const u = easeInOutCubic((t - 3.2) / 5)
      const root = this.ctx.terrain.root
      root.rotation.y = 0
      this.ctx.markers.root.rotation.y = 0
      const s = 0.05 + (1 - 0.05) * u
      root.scale.setScalar(s)
      this.ctx.markers.root.scale.setScalar(s)
      root.position.lerpVectors(new THREE.Vector3(0, 22, 46), new THREE.Vector3(0, 0, 0), u)
      this.ctx.markers.root.position.copy(root.position)
      const pos = new THREE.Vector3().lerpVectors(this.camFrom, this.camTo, u)
      const tgt = new THREE.Vector3().lerpVectors(this.tgtFrom, this.tgtTo, u)
      this.ctx.view.setPose(pos, tgt)
      if (t > 3.2 && t < 3.5) {
        this.ctx.setCaption('「——広げるぞ」')
        if (t < 3.3) this.ctx.sfx.play('whoosh')
      }
      if (u > 0.95) this.ctx.setCaption('気づけば、その上空にいる')
    } else if (t < 14) {
      this.ctx.markers.setLabelsVisible(true)
    } else {
      // 巻き戻してループ
      this.ctx.markers.setLabelsVisible(false)
      if (t > 15.7) this.ctx.setCaption('「これが、わしの歩いた国じゃ」')
    }
  }

  protected onDispose(): void {
    this.ctx.terrain.resetTransforms()
    this.ctx.terrain.root.rotation.y = 0
    const m = this.ctx.markers.root
    m.scale.setScalar(1)
    m.position.set(0, 0, 0)
    m.rotation.y = 0
    this.ctx.markers.setLabelsVisible(true)
    this.ctx.controls.enabled = true
  }
}
